import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { Action } from '@ngrx/store';

import * as ExceedingAmountActions from '../actions/exceeding-amount.actions';
import { IEntity } from '@proximus/entity-manager';
import { catchError, map, mergeMap } from 'rxjs/operators';
import {
  ExceedingAmountResponse,
  TechnicalError,
} from '@dch/products-business-logic';
import { ExceedingAmountService } from '../../services/exceeding-amount.service';

@Injectable({
  providedIn: 'root',
})
export class ExceedingAmountEffects {
  @Effect()
  exceedingAmount$: Observable<Action> = this.actions$.pipe(
    ofType(ExceedingAmountActions.GET_EXCEEDING_AMOUNT),
    mergeMap((action: ExceedingAmountActions.GetExceedingAmount) =>
      this.exceedingAmountService.getExceedingAmount(action.payload).pipe(
        map(
          (exceedingAmountResponseEntity: IEntity<ExceedingAmountResponse>) =>
            new ExceedingAmountActions.GetExceedingAmountSuccess(
              exceedingAmountResponseEntity.value,
            ),
        ),
        catchError((error: IEntity<TechnicalError>) =>
          of(
            new ExceedingAmountActions.GetExceedingAmountFailed(
              error.errorData as TechnicalError,
            ),
          ),
        ),
      ),
    ),
  );

  constructor(
    private actions$: Actions,
    private exceedingAmountService: ExceedingAmountService,
  ) {}
}
